export function authHeader() {
  let user = JSON.parse(localStorage.getItem("user"));
  let hotel = JSON.parse(localStorage.getItem("hotel"));
  if (user && user.access) {
    return {
      Authorization: "Bearer " + user.access,
      "x-timezone": hotel ? hotel.time_zone : "America/New_York",
    };
  } else {
    return {};
  }
}

export function authHeaderWithMultipartData() {
  let user = JSON.parse(localStorage.getItem("user"));
  let hotel = JSON.parse(localStorage.getItem("hotel"));
  if (user && user.access) {
    return {
      Authorization: "Bearer " + user.access,
      "Content-Type": "multipart/form-data",
      "x-timezone": hotel ? hotel.time_zone : "America/New_York",
    };
  } else {
    return {};
  }
}

export function pbxAuthHeader(domain_uuid = "") {
  let user = JSON.parse(localStorage.getItem("user"));
  if (user && user.access) {
    let header = { Authorization: "Bearer " + user.access };
    if (domain_uuid !== "") {
      header = {
        ...header,
        domain_uuid,
      };
    }
    return header;
  } else {
    return {};
  }
}

// Video bot API auth header
export function videoBotAuthHeader() {
  return {
    "x-api-key": "5JXcdYnDhN8uNB9xiXpcj7KORPo9yCo82gUGIf3L",
  };
}

export function videoBotAuthHeaderWithMultPartData() {
  return {
    "x-api-key": "5JXcdYnDhN8uNB9xiXpcj7KORPo9yCo82gUGIf3L",
    "Content-Type": "multipart/form-data",
  };
}
